export default function IconVolume({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      viewBox="0 0 24 24"
      fill="currentColor"
    >
      <path d="M3 9v6h4l5 4V5L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zm-2.5-9.5v2.06c2.89 1 5 3.77 5 7.44s-2.11 6.44-5 7.44v2.06c4.01-1.06 7-4.71 7-9.5s-2.99-8.44-7-9.5z"/>
    </svg>
  );
}